import { $, $$ } from 'utils/dom';
import Modal from 'modules/modal/modal';
import { fadeInFromBottom } from '../animations';
import { viewport } from '../getViewport';

export const storyBanners = () => {
  const banners = $$('.story-banner');
  banners.length &&
    banners.forEach(banner => {
      const modalOpener = $$('[data-modal-open', banner);
      const modal = $('.story-modal', banner);

      new Modal({
        modal,
        modalCloseBtns: $$('[data-modal-close]', modal),
        modalOpenBtns: modalOpener,
        focusOut: modalOpener,
      }).init();

      if (!banner.classList.contains('story-banner--no-animation')) {
        fadeInFromBottom(
          $$('.story-banner__content', banner),
          viewport.isReduced ? 0 : 150
        );
        fadeInFromBottom(
          $$('.story-banner__image', banner),
          viewport.isReduced ? 0 : 100
        );
      } else {
        fadeInFromBottom(
          $$('.story-banner__content', banner),
          viewport.isReduced ? 0 : 100
        );
      }
    });
};
